import { render, staticRenderFns } from "./MerchantOpenCardForShop.vue?vue&type=template&id=6680fe50&scoped=true&"
import script from "./MerchantOpenCardForShop.vue?vue&type=script&lang=js&"
export * from "./MerchantOpenCardForShop.vue?vue&type=script&lang=js&"
import style0 from "./MerchantOpenCardForShop.vue?vue&type=style&index=0&id=6680fe50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6680fe50",
  null
  
)

export default component.exports